@if (isPanelOpen$ | async; as isOpen) {
  <div
    class="websocket-debug-panel"
    [class.open]="isOpen"
    [style.width.px]="panelWidth">

    <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>

    <div class="panel-content">
      <div class="panel-header">
        <h2>WebSocket Debug Panel</h2>
        <div class="header-actions">
          <span class="keyboard-hint">Ctrl+Shift+X</span>
          <tn-icon-button
            name="close"
            library="mdi"
            class="toggle-button"
            ixTest="debug-panel-toggle"
            [attr.aria-label]="isOpen ? 'Close debug panel' : 'Open debug panel'"
            (click)="togglePanel()"
          ></tn-icon-button>
        </div>
      </div>

      <mat-tab-group
        class="panel-tabs"
        [selectedIndex]="selectedTabIndex$ | async"
        (selectedIndexChange)="onTabChange($event)">
        <mat-tab [label]="'Messages' | translate">
          <ix-websocket-tab></ix-websocket-tab>
        </mat-tab>
        <mat-tab [label]="'Mock Configurations' | translate">
          <ix-mock-configurations-tab></ix-mock-configurations-tab>
        </mat-tab>
        <mat-tab [label]="'Enclosure Mock' | translate">
          <ix-enclosure-mock-tab></ix-enclosure-mock-tab>
        </mat-tab>
        <mat-tab [label]="'Alert Classes' | translate">
          <ix-alert-classes-tab></ix-alert-classes-tab>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}
